import type { LucideIcon } from "lucide-react";
import { GlassPanel } from "@/shared/ui/layout";
import { ItemIcon, type ItemIconKey } from "@/shared/ui/core";

export interface KpiCardProps {
  icon: LucideIcon;
  /**
   * El "item" 3D de la marca (Anahí, 14-sep-2026). Cuando viene, manda
   * sobre `icon`: el chip violeta se sustituye por el objeto. `icon`
   * sigue siendo obligatorio a propósito — es el respaldo si el archivo
   * no carga y el que usan las tarjetas sin item propio.
   */
  item?: ItemIconKey;
  label: string;
  value: string;
  /** Una línea extra bajo la etiqueta, si el número necesita contexto. */
  hint?: string;
}

/**
 * La tarjeta de KPI del panel — el chip del icono en el VIOLETA firma
 * de It's The Best a la izquierda, el número grande al lado y la
 * etiqueta debajo. Nació en el dashboard de Compras (27-ago) y se
 * extrajo aquí en cuanto el dashboard general la necesitó también:
 * un KPI se ve IGUAL en todo el panel.
 */
export function KpiCard({ icon: Icon, item, label, value, hint }: KpiCardProps) {
  return (
    <GlassPanel className="relative p-4 transition hover:shadow-ds-float">
      <div className="relative flex items-center gap-3">
        {item ? (
          <ItemIcon item={item} size={52} className="-my-1" />
        ) : (
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-ds-violet-pop text-white shadow-[0_8px_18px_rgba(92,79,214,0.35)]">
            <Icon className="h-5 w-5" />
          </span>
        )}
        <div className="min-w-0">
          <p className="truncate text-[21px] font-semibold leading-tight text-ds-ink">{value}</p>
          {/* La etiqueta ENVUELVE hasta dos líneas: "Comisiones
              cubiertas" cortada a "COMISIONES CUBIE…" no informa. */}
          <p className="line-clamp-2 text-[11px] uppercase leading-snug tracking-ds-label text-ds-ink-3">
            {label}
          </p>
          {hint && <p className="truncate text-[11px] text-ds-ink-3">{hint}</p>}
        </div>
      </div>
    </GlassPanel>
  );
}
